import axios, { AxiosError } from 'axios';
import axiosInterseptor from '../../utils/axiosInterseptor';
import { adaptPhotos } from '../../utils/catalogUtils';

export default class PrivateData {
  static async getPrivateUser() {
    try {
      const response = await axiosInterseptor.get('user');
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateLoggingOut() {
    try {
      const response = await axiosInterseptor.delete('', {});
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateEditUserDate(array: any) {
    try {
      const response = await axiosInterseptor.put('', array);
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateUserOferta() {
    try {
      const response = await axiosInterseptor.get('user/oferta');
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateUserDealsHistoryBooking({
    id,
    signal,
  }: {
    id?: number;
    signal?: AbortSignal;
  }) {
    try {
      const filters: { stage: string[]; city?: number } = {
        stage: ['executing', 'lose'],
      };
      if (id) {
        filters.city = id;
      }

      const params = new URLSearchParams();
      params.append('filters', JSON.stringify(filters));

      const response = await axiosInterseptor.get(`deals?mode=filter&${params}`, { signal });
      const { data } = response;
      if (data.data && Array.isArray(data.data)) {
        data.data = data.data.map((item: any) => ({
          ...item,
          product: {
            ...item.product,
            photos: adaptPhotos(item.product.photos, data.meta, item.product.id),
          },
        }));
      }
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateUserDealsCurrentBooking() {
    try {
      const filters: { stage: string[] } = { stage: ['incoming'] };

      const params = new URLSearchParams();
      params.append('filters', JSON.stringify(filters));

      const response = await axiosInterseptor.get(`deals?mode=filter&${params}`);
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateUserDeal(id: number) {
    try {
      const response = await axiosInterseptor.get(`deals/deal/${id}`);
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateCancellationOferta() {
    try {
      const response = await axiosInterseptor.delete('user/oferta');
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async checkPreapprove() {
    try {
      const response = await axiosInterseptor.get('user/passport/check');
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateCollectionFavorite(
    ids: Array<number>,
    page: number,
    signal?: AbortSignal,
    cityId?: number,
  ) {
    const config = cityId
      ? {
          params: {
            products: JSON.stringify(ids),
            filters: JSON.stringify({ city: cityId }),
            page,
          },
          signal,
        }
      : {
          params: {
            products: JSON.stringify(ids),
            page,
          },
          signal,
        };

    try {
      const response = await axiosInterseptor.get('products?mode=filter', config);
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateFavoriteArrayId() {
    try {
      const response = await axiosInterseptor.get('favorites');
      const { data } = response;
      return data;
    } catch (error) {
      console.error('Ошибка при получении избранного массива ID');
      throw error;
    }
  }

  static async getPrivateFavoriteAddedArrayId(ids: Array<number>) {
    try {
      const response = await axiosInterseptor.post('favorites', {
        products: ids,
      });
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateAddetToCollectionFavorite(id: number, params: any) {
    try {
      const response = await axiosInterseptor.post('favorites/favorite', {
        product_id: id,
        config: params,
      });
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateDeleteCollectionFavorite(id: number) {
    try {
      const response = await axiosInterseptor.delete(`favorites/favorite?product_id=${id}`);
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateAddedPassportPhoto(photo: any) {
    const formData = new FormData();
    formData.append('photo', photo);

    try {
      const response = await axiosInterseptor.post('user/passport/photo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      const { data } = response;
      return data;
    } catch (error: any) {
      const responseData = error.response?.data;
      if (typeof responseData === 'object' && responseData !== null) {
        return { error: responseData.error || 'Неизвестная ошибка сервера' };
      }
      if (typeof responseData === 'string') {
        return { error: responseData };
      }
      return { error: error.message || 'Произошла ошибка при загрузке фото' };
    }
  }

  static async getPrivateAddedPassportAndUserFaceVideo(video: any) {
    const formData = new FormData();
    formData.append('photo', video);

    try {
      const response = await axiosInterseptor.post('user/video', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateUserAddetChats(id: number) {
    try {
      const response = await axiosInterseptor.post('user/chats', {
        product_id: id,
      });
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateUserAddetReview(product_id: number, text: string, score: number) {
    try {
      const response = await axiosInterseptor.post('user/reviews', {
        product_id,
        text,
        score,
      });
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getPrivateUserApartmentReservation(
    product_id: string,
    begin: string,
    end: string,
    adult_count: number,
    child_count: number,
    cashback: boolean,
    phone?: string | null,
  ) {
    try {
      const response = await axiosInterseptor.post('/deals/deal', {
        product_id,
        begin,
        end,
        adult_count,
        child_count,
        cashback,
        phone,
      });
      const { data } = response;
      return data;
    } catch (error) {
      const err = error as AxiosError;
      if (err.response && typeof err.response.data === 'string') {
        return {
          error: err.response.data,
        };
      }
      throw error;
    }
  }

  static async getPrivateUserDealStatusBooking(id: string) {
    const filters: { stage: string[] } = { stage: ['incoming'] };
    const params = new URLSearchParams();
    params.append('filters', JSON.stringify(filters));
    try {
      const response = await axiosInterseptor.get(`/deals?product_id=${id}&mode=filter&${params}`);
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getOrder(id: string) {
    try {
      const response = await axiosInterseptor.get(`payments/order/${id}`);
      const { data } = response;
      return data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          throw new Error(error.response.data);
        }
        throw new Error(error.message);
      }
      throw new Error('Произошла неизвестная ошибка. Попробуйте позже.');
    }
  }

  static async deleteUserDeals(id: number | string, reason: number) {
    try {
      const response = await axiosInterseptor.delete(`deals/deal/${id}?reason=${reason}`);
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  static async addPayment(
    deal_id: number,
    value: number,
    type: string,
    cashback?: boolean,
    bonuses?: boolean,
  ) {
    try {
      const response = await axiosInterseptor.post('/payments/payment', {
        deal_id,
        value,
        type,
        cashback,
        bonuses,
      });
      const { data } = response;
      return data;
    } catch (error) {
      console.error('Ошибка при попытке получения данных с сервера:', error);
      throw error;
    }
  }

  static async getBonusInformation() {
    try {
      const response = await axiosInterseptor.get('info/bonus');
      const { data } = response;
      return data;
    } catch (error) {
      console.error('Ошибка при попытке получения данных с сервера:', error);
      throw error;
    }
  }
}
